import template from './alertDialog.template.html';

export default {
  bindings: {},
  controller: class controller {
    constructor($mdMedia, $mdDialog, eventService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onAlertDialog((params) => {
          $mdDialog
            .show({
              targetEvent: params?.alert?.event || null,
              locals: {
                alerts: params?.alert?.alerts || [],
                icon: params?.alert?.icon || 'offline_bolt',
                title: params?.alert?.title || 'Alert'
              },
              multiple: true,
              template,
              controllerAs: '$ctrl',
              controller(alerts, icon, title) {
                const self = this;
                self.alerts = alerts;
                self.icon = icon;
                self.title = title;

                self.confirm = () => {
                  $mdDialog.hide();
                };
                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {
              //
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
